export const uploadImage = async (componentName, templateName, hd_id, file, fileName) => {
  try {
    const data = await getDownloadUrlAPI(componentName, templateName, hd_id, file, fileName);
    if (data && data.fileName) {
      return {
        fileName: data.fileName

      }
    }

  } catch (err) {
    console.log('err', err);

  }
};


export const getDownloadUrlAPI = async (componentName, templateName, hd_id, file, fileName) => {
  const bucketName = "hd-portal",
    fileSuffix = fileName;
  const params = new URLSearchParams();
  params.append('componentName', componentName);
  params.append('templateName', templateName);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileSuffix", fileSuffix);
  formData.append("bucketName", bucketName);
  const reqData = {
    body: formData,
    method: "POST",
    credentials: "include",
  };
  let queryURL = `/nodeapi/fileUploads/saveStoreImage?${params.toString()}`;
  return fetch(queryURL, reqData)
    .then(response => {
      return response.json();
    })
    .then(data => {
      console.log('data', data)
      return data;
    })
    .catch(error => {
      console.log("[ServiceClass] followersAndFollowingsAPI error", error);
    });
};